import { createFileRoute, Link, notFound } from '@tanstack/react-router';
import { ArrowLeft, ExternalLink, FileText } from 'lucide-react';
import { useLaudo } from '@/hooks/usePaciente';
import { LoadingState } from '@/components/shared/LoadingState';
import { ErrorState } from '@/components/shared/ErrorState';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { formatarData } from '@/lib/utils';

export const Route = createFileRoute('/pep-vida/_authed/laudos/$cdLaudo')({
  component: LaudoDetailPage,
});

function LaudoDetailPage() {
  const { cdLaudo } = Route.useParams();
  const cd = Number(cdLaudo);

  const { data: laudo, isLoading, error, refetch } = useLaudo(cd);

  if (isLoading) return <LoadingState />;
  if (error) {
    if ((error as Error).message.includes('nao encontrado')) throw notFound();
    return <ErrorState message={(error as Error).message} onRetry={() => refetch()} />;
  }
  if (!laudo) throw notFound();

  return (
    <div className="space-y-6 max-w-3xl mx-auto">
      <Link to="/pep-vida/dashboard">
        <Button variant="ghost" size="sm">
          <ArrowLeft className="mr-2 h-4 w-4" />
          Voltar
        </Button>
      </Link>
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center justify-between gap-2">
            <div className="flex items-center gap-2">
              <FileText className="h-4 w-4" />
              Laudo #{laudo.cd_laudo}
            </div>
            {laudo.ds_url_pdf && (
              <a href={laudo.ds_url_pdf} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-sm text-primary hover:underline">
                Abrir PDF
                <ExternalLink className="h-3 w-3" />
              </a>
            )}
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">
            Data: {formatarData(laudo.dt_laudo)} - Paciente: #{laudo.cd_paciente}
          </p>
          <pre className="mt-4 whitespace-pre-wrap rounded-md border bg-muted/30 p-4 text-sm font-mono">
            {laudo.ds_laudo}
          </pre>
        </CardContent>
      </Card>
    </div>
  );
}
